export default __webpack_public_path__ + "static/media/mansion-apartments.38c31fbc.JPG";